import { SERVICES_URL } from "../../config/config";
import axios from 'axios';
import axiosRetry from 'axios-retry';

axiosRetry(axios, {
  retries: 4,                               
  retryDelay: () => 2000,
  retryCondition: (error) => {
    const status = error.response?.status;
    return status === 404 || status === 204;
  }
});

const invoice = async ({ token, callbacks, params }) => {
     const res = await axios.get(SERVICES_URL.INVOICE.INOVICE, {
      params: {
        tdocu: params.tdocu,
        ndocu: params.ndocu,
        carrera: params.carrera,
        modo: params.modo,
        anio: params.anio,
        tipo_carrera: params.tipo_carrera,
        lugar: params.lugar,
        sector: params.sector
      },
      headers: { auth: token }
    });

    if (typeof callbacks === "function") {
        //callbacks(data);
        if (res.status == 200){
            let invoice = await res.data
            // .json()
            invoice = invoice.map(e=>{
                if ([50,590].includes(e?.concepto || -1)){
                    e.imprimir = 'Si'
                }
                return e
            })
            callbacks({
                success: true,
                data: invoice
            })
        }else{
            callbacks({
                success: false,
                error: await res.json()
            });
        }
    }
}

export default invoice;